import {request} from '../request';
import {ProductionNode} from './DeploymentNodes';

export const deleteDeploymentNode = async (nodeId: string) => {
  return await request<ProductionNode>({
    method: 'DELETE',
    url: '/edge/node',
    params: {
      nodeId,
    },
  });
};
